import { IPublicClientApplication } from '@azure/msal-browser';
import axios from 'axios';
import { getSilentRequest } from '../app/authentication/get-silent-request';
import { sanitizeObjectKeys, validateAndSanitizeUrl } from '../utils/input-validation';

export async function get<T>(
    url: string,
    instance: IPublicClientApplication,
    params: { [key: string]: string | number | string[] } = {}
): Promise<T> {
    // Validate and sanitize the URL
    const { isValid: urlValid, url: sanitizedUrl } = validateAndSanitizeUrl(url);
    if (!urlValid) {
        throw new Error('Invalid URL provided');
    }

    // Sanitize query parameters to prevent injection attacks
    const sanitizedParams = sanitizeObjectKeys(params);

    const tokenResponse = await instance.acquireTokenSilent(getSilentRequest());

    const config = {
        params: sanitizedParams,
        headers: {
            Authorization: `Bearer ${tokenResponse.accessToken}`
        },
        paramsSerializer: {
            indexes: null
        }
    };

    const response = await axios.get(sanitizedUrl, config);
    return response.data;
}
